// Demir Mock Data
// Demir siparişleri, tonaj takibi ve stok yönetimi

export const demirSiparisler = [
    {
        id: 'dm-001',
        siparisTarihi: '2026-01-05',
        teslimTarihi: '2026-01-07',
        tedarikci: 'İstanbul Demir Çelik',
        supplierId: 'comp-5',       // companies.id FK — cari hesap entegrasyonu için
        miktar: 10,
        birim: 'ton',
        cap: 'Ø12',
        kalite: 'B420C',
        birimFiyat: 18000,
        toplamFiyat: 180000,
        kdvOrani: 20,
        kdvTutari: 36000,
        kdvDahilToplam: 216000,
        durum: 'teslim',
        insaatId: 'c1',             // insaatlar.js id değerleriyle eşleşir
        stokMiktar: 2,
        kullanilanMiktar: 8,
        scheduledPaymentId: 'sp1',  // planliOdemeler.js sp1 bağlantısı
        not: 'Temel demiri — sp1 ile bağlantılı',
        createdAt: '2026-01-05T10:00:00Z',
        updatedAt: '2026-01-15T14:00:00Z',
    },
    {
        id: 'dm-002',
        siparisTarihi: '2026-01-05',
        teslimTarihi: '2026-01-07',
        tedarikci: 'İstanbul Demir Çelik',
        supplierId: 'comp-5',
        miktar: 15,
        birim: 'ton',
        cap: 'Ø16',
        kalite: 'B420C',
        birimFiyat: 28500,
        toplamFiyat: 427500,
        kdvOrani: 20,
        kdvTutari: 85500,
        kdvDahilToplam: 513000,
        durum: 'teslim',
        insaatId: 'c1',
        stokMiktar: 3,
        kullanilanMiktar: 12,
        scheduledPaymentId: null,
        not: 'Kolon demiri',
        createdAt: '2026-01-05T10:00:00Z',
        updatedAt: '2026-01-16T09:00:00Z',
    },
    {
        id: 'dm-003',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-12',
        tedarikci: 'İstanbul Demir Çelik',
        supplierId: 'comp-5',
        miktar: 30,
        birim: 'ton',
        cap: 'Ø8',
        kalite: 'B420C',
        birimFiyat: 27500,
        toplamFiyat: 825000,
        kdvOrani: 20,
        kdvTutari: 165000,
        kdvDahilToplam: 990000,
        durum: 'teslim',
        insaatId: 'c1',
        stokMiktar: 10,
        kullanilanMiktar: 20,
        scheduledPaymentId: null,
        not: 'Etriye demiri',
        createdAt: '2026-01-10T08:00:00Z',
        updatedAt: '2026-01-17T11:00:00Z',
    },
    {
        id: 'dm-004',
        siparisTarihi: '2026-01-15',
        teslimTarihi: null,
        tedarikci: 'İstanbul Demir Çelik',
        supplierId: 'comp-5',
        miktar: 20,
        birim: 'ton',
        cap: 'Ø20',
        kalite: 'B500C',
        birimFiyat: 30000,
        toplamFiyat: 600000,
        kdvOrani: 20,
        kdvTutari: 120000,
        kdvDahilToplam: 720000,
        durum: 'bekliyor',
        insaatId: 'c1',
        stokMiktar: 0,
        kullanilanMiktar: 0,
        scheduledPaymentId: null,
        not: 'Kirişler için sipariş',
        createdAt: '2026-01-15T14:00:00Z',
        updatedAt: '2026-01-15T14:00:00Z',
    },
    {
        id: 'dm-005',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-10',
        tedarikci: 'İstanbul Demir Çelik',
        supplierId: 'comp-5',
        miktar: 18,
        birim: 'ton',
        cap: 'Ø14',
        kalite: 'B420C',
        birimFiyat: 28200,
        toplamFiyat: 507600,
        kdvOrani: 20,
        kdvTutari: 101520,
        kdvDahilToplam: 609120,
        durum: 'teslim',
        insaatId: 'c2',
        stokMiktar: 8,
        kullanilanMiktar: 10,
        scheduledPaymentId: null,
        not: 'Perde demiri',
        createdAt: '2026-01-08T09:00:00Z',
        updatedAt: '2026-01-14T16:00:00Z',
    },
];

// Demir çapları
export const demirCaplari = [
    { key: 'Ø8', label: 'Ø8 mm', kullanim: 'Etriye' },
    { key: 'Ø10', label: 'Ø10 mm', kullanim: 'Etriye, Döşeme' },
    { key: 'Ø12', label: 'Ø12 mm', kullanim: 'Kolon, Kiriş' },
    { key: 'Ø14', label: 'Ø14 mm', kullanim: 'Kiriş, Perde' },
    { key: 'Ø16', label: 'Ø16 mm', kullanim: 'Kolon, Kiriş' },
    { key: 'Ø18', label: 'Ø18 mm', kullanim: 'Kolon' },
    { key: 'Ø20', label: 'Ø20 mm', kullanim: 'Kolon, Kiriş' },
    { key: 'Ø22', label: 'Ø22 mm', kullanim: 'Özel yapılar' },
    { key: 'Ø25', label: 'Ø25 mm', kullanim: 'Özel yapılar' },
];

// Demir kaliteleri
export const demirKaliteleri = [
    { key: 'B420C', label: 'B420C', aciklama: 'Standart mukavemet' },
    { key: 'B500C', label: 'B500C', aciklama: 'Yüksek mukavemet' },
];

// Stok özeti
export const getDemirStok = (insaatId) => {
    const filtered = insaatId
        ? demirSiparisler.filter(s => s.insaatId === insaatId && s.durum === 'teslim')
        : demirSiparisler.filter(s => s.durum === 'teslim');

    const stokByKalem = {};
    filtered.forEach(s => {
        const key = s.cap;
        if (!stokByKalem[key]) {
            stokByKalem[key] = { cap: s.cap, stok: 0, kullanilan: 0 };
        }
        stokByKalem[key].stok += s.stokMiktar;
        stokByKalem[key].kullanilan += s.kullanilanMiktar;
    });

    return Object.values(stokByKalem);
};

// İstatistikler
export const getDemirStats = (insaatId) => {
    const filtered = insaatId
        ? demirSiparisler.filter(s => s.insaatId === insaatId)
        : demirSiparisler;

    const toplamTonaj = filtered.reduce((acc, s) => acc + s.miktar, 0);
    const teslimTonaj = filtered.filter(s => s.durum === 'teslim').reduce((acc, s) => acc + s.miktar, 0);
    const bekleyenTonaj = filtered.filter(s => s.durum === 'bekliyor').reduce((acc, s) => acc + s.miktar, 0);
    const stokTonaj = filtered.filter(s => s.durum === 'teslim').reduce((acc, s) => acc + s.stokMiktar, 0);
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    return {
        toplamTonaj,
        teslimTonaj,
        bekleyenTonaj,
        stokTonaj,
        toplamMaliyet,
        siparisAdedi: filtered.length,
    };
};

// Helper: insaata göre filtrele
export const getDemirByInsaat = (insaatId) => {
    if (!insaatId) return demirSiparisler;
    return demirSiparisler.filter(s => s.insaatId === insaatId);
};
